import {
  AddOneSlotToLoadingQueue,
  RemoveOneSlotToLoadingQueue,
} from "../../loading/loading.store";
import ShowNotification from "../../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../../utils/configuration";
import Service from "../../../../api/api-service";
import { ApiUrl } from "../../../../api/api-url";
import { CONSTANT } from "../../../../constants/constant";
const service = new Service();

export const GET_RANKING_LOOKUP_OK = "GET_RANKING_LOOKUP_OK";
export const GET_RANKING_LOOKUP_ERR = "GET_RANKING_LOOKUP_ERR";

export const rankingAction = {
  getRankingLookup,
};

function getRankingLookupOk(payload) {
  return { type: GET_RANKING_LOOKUP_OK, payload };
}
function getRankingLookupErr(payload) {
  return { type: GET_RANKING_LOOKUP_ERR, payload };
}

function getRankingLookup() {
  return function (dispatch) {
    dispatch(AddOneSlotToLoadingQueue);
    return service
      .get(ApiUrl.GetLookupRanking)
      .then((response) => {
        dispatch(getRankingLookupOk(response));
        dispatch(RemoveOneSlotToLoadingQueue);
      })
      .catch((error) => {
        dispatch(getRankingLookupErr(error));
        dispatch(RemoveOneSlotToLoadingQueue);
        if (error && error.errorMessage) {
          ShowNotification(error.errorMessage, NotificationMessageType.Error);
        } else {
          ShowNotification(
            CONSTANT.message.error_unknown,
            NotificationMessageType.Error
          );
        }
      });
  };
}
